import { api, tokenStore } from "./apiClient";

export const twofaService = {
  status: async () => (await api.get("/auth/2fa/status")).data,
  setup: async (setupToken) =>
    (await api.post("/auth/2fa/setup", {}, setupToken ? { headers: { "X-2FA-Pending": setupToken } } : {})).data,
  enable: async (code, setupToken) =>
    (await api.post("/auth/2fa/enable", { code }, setupToken ? { headers: { "X-2FA-Pending": setupToken } } : {})).data,
  async verify(pendingToken, code) {
    const { data } = await api.post("/auth/2fa/verify", { pending_token: pendingToken, code });
    tokenStore.set(data.access_token);
    return data.user;
  },
  disable: async (password) => (await api.post("/auth/2fa/disable", { password })).data,
  regenerate: async (password) => (await api.post("/auth/2fa/recovery/regenerate", { password })).data,
};
